<template>
  <Container
    id="heading"
  >
    <HeroCard
      :heading="t('jc.view.team.hero.title')"
      :paragraph="t('jc.view.team.hero.text')"
      :image="{
        src: 'images/nature/hill_sunshine.png',
        alt: t('jc.view.team.hero.banner.alt'),
      }"
      :float="{
        src: 'images/skin_renders/compositions/team.png',
        alt: t('jc.view.team.hero.float.alt'),
      }"
      :label="t('jc.view.team.hero.button.label')"
      :icon="'user-plus'"
      :to="localePath({ name: 'participate' })"
    />
  </Container>

  <Container
    id="team-member"
  >
    <div
      class="flex flex-col gap-12"
    >
      <template
        v-for="departmentKey in departmentKeys"
        :key="departmentKey"
      >
        <div
          v-if="departmentUsers(departmentKey).length > 0"
          class="flex flex-col gap-8"
          :class="[ 'department-' + DepartmentData[departmentKey].nameKey ]"
        >
          <Heading
            :icon="DepartmentData[departmentKey].icon"
            :label="t(`jc.department.${departmentKey}.label`)"
          />
          <div
            class="grid mobile:grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-4 gap-4"
          >
            <template
              v-for="user in departmentUsers(departmentKey)"
              :key="user.id"
            >
              <UserShowcaseCard
                :user="user"
              />
            </template>
          </div>
        </div>
      </template>
    </div>
  </Container>
</template>

<script setup lang="ts">
import {Department, isTeamRole, type User, UserRoleData, DepartmentData} from "~/composables/charon";

const { t } = useI18n()
const localePath = useLocalePath()
const { charon } = useCharon()

definePageMeta({
  nameKey: 'team'
})

const departmentKeys = [
  Department.MANAGEMENT,
  Department.SUPPORT,
  Department.PROMOTION,
  Department.DEVELOPMENT,
  Department.CREATIVE,
]

const { data: users } = useAsyncData(
  () => charon<User[]>(`/users?team[eq]=true`),
  {
    lazy: true
  }
)

function departmentUsers(departmentKey: Department) {
  return (users.value || [])
    .filter(user => {
      // match for first team role
      const role = user.roles?.find(role => isTeamRole(role))
      if (role === undefined) {
        return false
      }
      return UserRoleData[role].department == departmentKey
    })
    .sort((user1, user2) => {
      // get their individual role priority
      const role1 = UserRoleData[user1.roles!!.find(role => isTeamRole(role))!!]
      const role2 = UserRoleData[user2.roles!!.find(role => isTeamRole(role))!!]

      // check if their roles differ
      const roleDiff = role2.priority - role1.priority
      if (roleDiff != 0) {
        return roleDiff
      }

      // sort by names
      return user1.name.localeCompare(user2.name)
    })
}
</script>
